import { ChatbotAnswer } from '../../domain/ChatbotSlice/ChatbotAnswer';
import { ChatbotAskPacker } from '../../domain/ChatbotSlice/ChatbotAskPacker';
import ApiWrapperAuthenticated from '../Common/ApiWrapperAuthenticated';

export class ChatbotPackerRepository extends ApiWrapperAuthenticated<ChatbotAnswer> {
    constructor() {
        super('chatbot/packer/');
    }

    async ask(message: ChatbotAskPacker): Promise<ChatbotAnswer | null> {
        return await this.postAuthenticatedCustom({url: '', data: message});
    }
}
